const initState = {
  keyword: '',
  results: null
}

export default (state = initState, action) => {
  const { type, payload } = action
  
  switch (type) {
    case "SEARCH_KEYWORD":
      state.keyword = payload
      break
    case "SEARCH_RESULT":
      state.results = payload
      break
    // default:
    //   stateClone = initState
    //   break
  }
  return state
}